import styled from "styled-components";
import { Grid } from "semantic-ui-react";

import { theme } from "./theme";

export const WhiteContainer = styled.div`
  background-color: #fff;
  display: flex;
  min-height: 100vh;
`;

export const FloatedContainer = styled.div`
  padding-top: 50px;
  padding-bottom: 2.5rem;
`;

const ContentGridLimits = styled(Grid)`
  max-width: 1300px;
  background-color: #fff;
  @media (max-width: 1600px) {
    max-width: 83%;
  }

  @media (max-width: 1450px) {
    max-width: 90%;
  }
`;

export const ContentGrid = styled(ContentGridLimits)({
  display: "flex!important",
  marginTop: "0!important",
  marginLeft: "0!important",
  width: "100%",
  padding: "40px 73px 60px 41px !important",
  flexWrap: "wrap",
});

export const ContentGridSection = styled(Grid)({
  paddingTop: "20px !important",
  paddingLeft: "40px !important",
  marginLeft: "0 !important",
  maxWidth: `${theme.maxWidthSizeContainer}px`,
  // overflowX: "scroll",

  "@media (max-width: 1600px)": {
    maxWidth: "83%",
  },

  "@media (max-width: 1550px)": {
    maxWidth: "90%",
  },

  "@media (max-width: 1450px)": {
    maxWidth: "90%",
  },
});

export const SocialGrid = styled(Grid)`
  padding-left: ${(props: any) =>
    props.leftpadding ? theme.size[props.leftpadding as keyof typeof theme.size] + "px" : "inherit"};
  padding-right: ${(props: any) => (props.rightpadding ? props.rightpadding + "px" : "inherit")};
`;

export const InternalGrid = styled(Grid)({
  maxWidth: `${theme.maxWidthSizeContainer}px`,
  marginLeft: "0 !important",
  overflow: "hidden",
});

export const SCSubtitle = styled.p`
  color: ${theme.lineColor};
  font-family: "Open Sans", sans-serif;
  font-size: 1.15em;
  letter-spacing: -0.24px;
  line-height: 21.79px;
  text-align: left;
  white-space: pre-line;
`;

export const RowBasicPadding = styled(Grid.Row)({
  paddingBottom: "15px !important",
});

export const SocialBasicRow = styled(Grid.Row)({
  padding: "0px !important",
});

export const SocialBasicContentRow = styled(Grid.Row)({
  padding: "0px 0px 10px 20px !important",
});

export const SocialRowGrid = styled(Grid.Row)({
  paddingBottom: "20px !important",
  paddingLeft: "15px",
});

export const BlueTag = styled.span`
  background: ${theme.buttonColor};
  color: white;
  font-family: "Open Sans", sans-serif;
  float: left;
  height: 25px;
  border-radius: 5px;
  padding: 1px 8px;
  margin: 3px 5px 0px 10px;
`;

export const TitleLabel = styled.label`
  font-weight: 700;
  color: rgba(0, 0, 0, 0.87);
`;

const height = "36px";
const thumbHeight = 30;
const trackHeight = "6px";

const thumbColor = "rgba(58,171,239, .6)";
const thumbMiddleColor = "rgba(58,171,239, .7)";
const thumbBorderColor = "rgba(255,255,255, .1)";
const upperBackground = `linear-gradient(to bottom, ${theme.borderColor}, ${theme.borderColor}) 100% 50% / 100% ${trackHeight} no-repeat transparent`;
const lowerBackground = `linear-gradient(to bottom, ${theme.primaryColor}, ${theme.primaryColor}) 100% 50% / 100% ${trackHeight} no-repeat transparent`;

const makeLongShadow = (color: string, size: string) => {
  let i = 0;
  let shadow = `${i}px 0 0 ${size} ${color}`;

  for (; i < 706; i++) {
    shadow = `${shadow}, ${i}px 0 0 ${size} ${color}`;
  }
  return shadow;
};

export const SliderInput = styled.input`
  overflow: hidden;
  display: block;
  appearance: none;
  width: 100%;
  margin: 0;
  height: ${height};
  cursor: pointer;

  &:focus {
    outline: none;
  }

  /* Track left section */
  &::-webkit-slider-runnable-track {
    width: 100%;
    height: ${height};
    background: ${lowerBackground};
  }

  /* Track right section */
  &::-webkit-slider-thumb {
    position: relative;
    appearance: none;
    height: ${thumbHeight}px;
    width: ${thumbHeight}px;
    background-size: cover;
    background-image: radial-gradient(circle, ${thumbColor}, ${thumbMiddleColor}, ${thumbBorderColor});
    border-radius: 100%;
    border: 0;
    top: 50%;
    transform: translateY(-50%);
    z-index: 20;
    box-shadow: ${makeLongShadow(`${theme.borderColor}`, "-12px")};
    transition: background-color 150ms;
  }

  &::-moz-range-track,
  &::-moz-range-progress {
    width: 100%;
    height: ${height};
    background: ${upperBackground};
  }

  &::-moz-range-progress {
    background: ${lowerBackground};
  }

  &::-moz-range-thumb {
    appearance: none;
    margin: 0;
    height: ${thumbHeight};
    width: ${thumbHeight};
    background: ${thumbColor};
    border-radius: 100%;
    border: 0;
    transition: background-color 150ms;
    background-image: radial-gradient(circle, ${thumbColor}, ${thumbMiddleColor}, ${thumbBorderColor});
  }

  &::-ms-track {
    width: 100%;
    height: ${height};
    border: 0;
    /* color needed to hide track marks */
    color: transparent;
    background: transparent;
  }

  &::-ms-fill-lower {
    background: ${upperBackground};
  }

  &::-ms-fill-upper {
    background: ${upperBackground};
  }

  &::-ms-thumb {
    appearance: none;
    height: ${thumbHeight};
    width: ${thumbHeight};
    background-image: radial-gradient(circle, ${thumbColor}, ${thumbMiddleColor}, ${thumbBorderColor});
    border-radius: 100%;
    border: 0;
    transition: background-color 150ms;
    /* IE Edge thinks it can support -webkit prefixes */
    top: 0;
    margin: 0;
    box-shadow: none;
  }
`;
